export default "__VITE_ASSET__84a80f4b__"